module.exports = __webpack_public_path__ + "static/media/pa-lungs@3x.eae86621.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pa-lungs@3x.png
// module id = 1723
// module chunks = 0